export const SUBMENUS = {
  CONTROLE_PAGAMENTOS: {
    NOMEDEPARTAMENTO: 'Financeiro e Controladoria',
    CAMINHO: '/mod/eTes/controlepagamentos.php',
    SUBMENU: 'Controle de pagamentos',
    MENU: 'Pagamentos',
    CODDEPARTAMENTO: 4,
    CODSUBMENU: 256,
    PROJETO: '1',
    FIXADO: 'S',
    ICONE: 'money',
    CORFUNDO: 'fundo-cor-sistema'
  },
  ADICIONAR_TELAS: {
    NOMEDEPARTAMENTO: 'Fixe até 3 páginas aqui',
    CAMINHO: '',
    SUBMENU: 'Destaque seus favoritos',
    MENU: 'Home',
    CODDEPARTAMENTO: 0,
    CODSUBMENU: 0,
    PROJETO: '1',
    FIXADO: 'S',
    ICONE: 'pin'
  },
  CAPITAL_FLOW: {
    NOMEDEPARTAMENTO: 'Capital Flow',
    CAMINHO: '/plataforma_capital_flow/gestao-cessao-titulos',
    SUBMENU: 'Capital Flow',
    MENU: 'Capital Flow',
    CODDEPARTAMENTO: 3,
    CODSUBMENU: 107,
    PROJETO: '4',
    FIXADO: 'N',
    ICONE: 'money'
  },
  REMESSAS_FINANCEIRO: {
    NOMEDEPARTAMENTO: 'Remessas',
    CAMINHO: '/remessas/criadas',
    SUBMENU: 'Remessas',
    MENU: 'Remessas',
    CODDEPARTAMENTO: 4,
    CODSUBMENU: 346,
    PROJETO: '4',
    FIXADO: 'N',
    ICONE: 'money'
  },
  CREDITO_ANALISE: {
    NOMEDEPARTAMENTO: 'Mesa de Crédito',
    CAMINHO: '/mod/apps/eCredito/view/creditoMesa.php',
    SUBMENU: 'Mesa de Crédito',
    MENU: 'Credito',
    MENU_ID: 8,
    CODDEPARTAMENTO: 1,
    CODSUBMENU: 24,
    PROJETO: '1',
    FIXADO: 'N',
    ICONE: 'money'
  }
};
